// import style from "../../../CreateNotification/create_noti.module.scss";
import { setProfileView } from "pages/Councillors/counsilorSlice";
import { useDispatch } from "react-redux";
import { BackArrow } from "themes/Icon";

import style from "../../CreateNotification/create_noti.module.scss";
function Header({ isDetails }) {
  const dispatch = useDispatch();

  return (
    <div
      className={`flex align-center justify-between w-full ${style["header-container"]}`}
    >
      <div className="flex align-center gap-2">
        <span
          onClick={() => dispatch(setProfileView(false))}
          className="pointer"
        >
          <BackArrow />
        </span>
        <h2 className="page-title">
          {isDetails ? "Councillor details" : "Add councillor"}
        </h2>
      </div>
    </div>
  );
}

export default Header;
